import React, { useState } from "react";

/**
 * Image with automatic fallback if load fails.
 * Shows a graceful placeholder with the title as text on stone background.
 * Never displays the browser's broken-image icon.
 */
export default function SmartImage({ src, alt = "", className = "", fallbackText = "Rarium" }) {
  const [failed, setFailed] = useState(false);
  const isValid = src && typeof src === "string" && src.startsWith("http");

  if (!isValid || failed) {
    return (
      <div
        className={`bg-stone-200 flex items-center justify-center text-stone-500 ${className}`}
        role="img"
        aria-label={alt || fallbackText}
      >
        <div className="text-center px-4">
          <div className="font-serif text-4xl leading-none opacity-40">◇</div>
          <div className="mt-2 font-serif text-sm max-w-[180px] line-clamp-3">{fallbackText || alt || "Immagine non disponibile"}</div>
        </div>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className={className}
      onError={() => setFailed(true)}
    />
  );
}
